$(document).on('click', '.files_page', function(){
	var page = $(this).data('page');
	var container = $(this).parents('.ajax_files_cont');
	var p = container.data('p');

	incube_ajax('files', 'html', 'get_list_page', {'p': p, 'page': page}, function(response){
		if(response)
			container.html(response);
	});
});